<template>
  <el-dialog
    title="Volume"
    :visible.sync="dialog"
    :fullscreen="true"
    :close-on-click-modal="false"
  >
    <el-form :model="form">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <el-form-item label="Quantidade">
            <el-input type="number" v-model="form.quantity" maxlength="10">
              <el-button slot="append" type="default" @click="add()"
                >Adicionar</el-button
              >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-tabs
      v-model="editableTabsValue"
      type="card"
      editable
      @edit="handleTabsEdit"
    >
      <el-tab-pane
        v-for="item in tabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
        :closable="+item.name !== 1"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('altura')" prop="height">
              <el-input
                type="number"
                v-model="item.height"
                ref="height"
                :min="0"
                :precision="0"
                :controls="false"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('largura')" prop="width">
              <el-input
                type="number"
                v-model="item.width"
                ref="width"
                :min="0"
                :precision="0"
                :controls="false"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="6"
            :xl="4"
            style="margin-bottom: 15px"
          >
            <el-form-item :label="$t('comprimento')" prop="length">
              <el-input
                type="number"
                ref="length"
                v-model="item.length"
                :min="0"
                :precision="0"
                :controls="false"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save()">Salvar</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "PrePostDC",
  props: ["height", "width", "length"],
  methods: {
    open(height, width, length) {
      this.tabs[0].width = width;
      this.tabs[0].height = height;
      this.tabs[0].length = length;
      this.dialog = true;
    },
    add() {
      const vm = this;
      const quantity = +vm.form.quantity;
      let current = +vm.tabs[vm.tabs.length - 1].name;

      for (let i = 0; i < quantity; i++) {
        current++;
        vm.tabs.push({
          title: "Volume " + current,
          name: current,
        });
      }
    },
    remove(item) {
      const vm = this;
      vm.tableData.splice(
        vm.tableData.findIndex((x) => x.item == item),
        1
      );
    },
    clear() {
      const vm = this;
      vm.tableData = [];
    },
    handleTabsEdit(targetName, action) {
      console.log(targetName, action);
      if (action === "remove") {
        let tabs = this.tabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.tabs = tabs.filter((tab) => tab.name !== targetName);
      }
    },
    save() {
      const vm = this;
      this.dialog = false;
      vm.$emit("saved", vm.tabs);
    },
  },
  data() {
    return {
      tableData: [],
      dialog: false,
      editableTabsValue: 1,
      tabs: [
        {
          title: "Volume 1",
          name: 1,
          width: 0,
          height: 0,
          length: 0,
        },
      ],
      form: {
        quantity: 0,
      },
    };
  },
};
</script>
